import { SVGProps } from 'react';

const Shapes = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8.3 10a.7.7 0 0 1-.626-1.079l3.726-5.92a.7.7 0 0 1 1.198-.044L16.3 8.9a.7.7 0 0 1-.572 1.1zM9 14H4a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1M17.5 21a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
    />
  </svg>
);
export default Shapes;
